export const SESSION_ERRORS = new Set([
  "session_required",
  "session_or_userid_required",
  "unauthorized",
]);

export function getSuiteBasePath(): string {
  const raw = window.location.pathname || "/";
  const idx = raw.toLowerCase().indexOf("/presence");
  const p = (idx >= 0 ? raw.slice(0, idx) : raw).replace(/\/+$/u, "");
  return p === "/" ? "" : p;
}

export function getSuiteApiBase(): string {
  if (window.__aureliaOwnSite) return "/api_suite";
  return `${getSuiteBasePath()}/api_suite`;
}

export function getPresenceApiBase(): string {
  if (window.__aureliaOwnSite) return "/presence/api";
  return `${getSuiteBasePath()}/presence/api`;
}

export function getWhoamiUrl(): string {
  return `${getSuiteApiBase()}/session/whoami.php`;
}

export function isEmbeddedInHub(): boolean {
  try {
    return window.parent !== window;
  } catch {
    return false;
  }
}

export function syncUserIdFromQuery(): string | null {
  if (window.__aureliaOwnSite) return null;
  try {
    const q = new URLSearchParams(window.location.search);
    const v = q.get("suite_user_id") || q.get("userId");
    if (v && /^\d+$/.test(v)) {
      sessionStorage.setItem("suite_user_id", v);
      localStorage.setItem("suite_user_id", v);
      localStorage.setItem("userId", v);
      window.dispatchEvent(new CustomEvent("suiteUserIdReceived", { detail: { userId: v } }));
      return v;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function readUserId(): string {
  if (window.__aureliaOwnSite) return "";
  const fromShared = window.readStoredSuiteUserId?.();
  if (fromShared != null && String(fromShared) !== "") return String(fromShared);
  try {
    const local = localStorage.getItem("suite_user_id") || localStorage.getItem("userId");
    if (!local || !/^\d+$/.test(local)) return "";
    return local;
  } catch {
    return "";
  }
}
